import { housingFinanceAgenciesApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const HOUSING_FINANCE_AGENCIES_ACTION_TYPE = createNamedActions('housingFinanceAgencies', {
  GET_HOUSING_FINANCE_AGENCIES: 'GET_HOUSING_FINANCE_AGENCIES',
});

export const getHousingFinanceAgenciesAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await housingFinanceAgenciesApi.getHousingFinanceAgencies(params);

  return dispatch({
    type: HOUSING_FINANCE_AGENCIES_ACTION_TYPE.GET_HOUSING_FINANCE_AGENCIES,
    payload: data,
  });
});
